<template>
    <div class="rent-interval">
        <div v-if="finalViewonly">
            <FormItem label="单价区间">
                <span>
                    {{ info.minPrice }} 元/㎡/月——{{ info.maxPrice }}
                    元/㎡/月
                </span>
            </FormItem>
        </div>
        <div v-else class="flex" style="line-height: 0">
            <FormItem
                prop="minPrice"
                class="rent-interval-field flex-item grow"
            >
                <input-number
                    v-model="info.minPrice"
                    :min="0"
                    required-message="最小单价必填"
                    @on-change="minPriceChange"
                >
                    <span slot="append">元/㎡/月</span>
                </input-number>
            </FormItem>
            <div style="margin: 12px 5px">——</div>
            <FormItem
                prop="maxPrice"
                class="rent-interval-field flex-item grow"
            >
                <input-number
                    v-model="info.maxPrice"
                    :min="0"
                    required-message="最高单价必填"
                >
                    <span slot="append">元/㎡/月</span>
                </input-number>
            </FormItem>
            <!-- <span class="text">若录入合同时单价低于最小值，则无法录入</span> -->
        </div>
    </div>
</template>

<script>
import { Field } from 'ivux'

export default {
    mixins: [Field],
    props: {
        info: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        innerRules() {
            return this.required
                ? {
                      minPrice: [{ required: true, message: '最小价格必填' }],
                      maxPrice: [{ required: true, message: '最高价格必填' }],
                  }
                : {}
        },
    },
    methods: {
        minPriceChange() {
            this.$emit('on-min-price-change')
        },
    },
}
</script>

<style lang="less" scoped>
.rent-interval {
    position: relative;

    &-field {
        flex-basis: 20px;
    }

    .text {
        line-height: 18px;
        position: absolute;
        top: -20px;
        left: 0;
        color: #c5c8ce;
    }
}
</style>
